module.exports = __webpack_public_path__ + "img/ss-1.c65ab772.svg";